import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let auxApiPromise: Promise<AxiosInstance> | null = null;
export const getAuxApi = async () => {
  if (auxApiPromise) return auxApiPromise;

  auxApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return auxApiPromise;
};

export interface AuxEntity {
  id: number;
  nombre: string;
}

export interface GetRelationFieldSectionProps {
  nombre?: string;
}

export interface ProcedenciaEntity {
  Id: string;
  Nombre: string;
}

export interface DriverEntity {
  id: number;
  nombreApellido: string;
}

export interface EquipmentEntity {
  id: number;
  nombre: string;
  patente?: string;
}

export const getListadoHobbies = async (
  props: GetRelationFieldSectionProps,
) => {
  const api = await getAuxApi();

  if (!api) return null;
  const response = await api.get(
    `/Auxiliares/Hobbies?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const getListadoProfesiones = async (
  props: GetRelationFieldSectionProps,
) => {
  const api = await getAuxApi();

  if (!api) return null;
  const response = await api.get(
    `/Auxiliares/Profesiones?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const getListadoNivelesEstudio = async () => {
  const api = await getAuxApi();

  if (!api) return null;
  const response = await api.get("/Auxiliares/NivelesEstudio");
  return response.data;
};

export const getListadoEstadosCiviles = async () => {
  const api = await getAuxApi();

  if (!api) return null;
  const response = await api.get("/Auxiliares/EstadosCiviles");
  return response.data;
};

export const getListadoSexosBiologicos = async () => {
  const api = await getAuxApi();

  if (!api) return null;
  const response = await api.get("/Auxiliares/SexosBiologicos");
  return response.data;
};

export interface GetMotivosProps {
  esRechazo?: boolean;
  idTipoSolicitud?: number;
  tipoMotivo?: number
}

export const getMotivos = async (props: GetMotivosProps) => {
  const api = await getAuxApi();
  if (!api) return null;
  const response = await api.get(
    `/Auxiliares/GetMotivos?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export const getListadoGranos = async () => {
  const api = await getAuxApi();
  if (!api) return null;
  const response = await api.get(
    `/Auxiliares/Granos`,
  );

  return response.data;
}

export const getProcedencias = async () => {
  const api = await getAuxApi();

  if (!api) return null;
  const response = await api.get(
    `/Procedencias`,
  );
  return response.data;
};

export const getChoferes = async (): Promise<DriverEntity[] | null> => {
  const api = await getAuxApi();
  if (!api) return null;

  const response = await api.get(`/Choferes`);
  return response.data;
};

export interface GetEquiposProps {
  idChofer?: number;
}

export const getEquipos = async (props: GetEquiposProps = {}): Promise<EquipmentEntity[] | null> => {
  const api = await getAuxApi();
  if (!api) return null;

const queryString = objectToQueryStringWithArray(props);
const url = queryString ? `/Equipos?${queryString}` : '/Equipos';
const response = await api.get(url);
  return response.data;
};

export interface GetEquiposDisponiblesProps {
  idChofer: number;
  fechaEntrega: string;
  tipoModulo: number
}

export const getEquiposDisponibles = async (
  props: GetEquiposDisponiblesProps,
): Promise<EquipmentEntity[] | null> => {
  const api = await getAuxApi();
  if (!api) return null;

  const response = await api.get(
    `/Equipos/All/Disponibles?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const getTiposModulo = async ():Promise<TipoModulo[] | null> => {
  const api = await getAuxApi();
  if (!api) return null;

  const response = await api.get(`/TipoModulo`);
  return response.data;
}

export interface TipoModulo {
  id: number
  descripcion: string
}